var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNationalDevelopment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Performance-Money-Increase--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Performance Money Increase Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.42 6.37a0.5 0.5 0 0 1 -0.68 0l-2.85 -2.23a2.5 2.5 0 0 0 -3.33 0.18l-6.87 6.87a1.49 1.49 0 0 0 0 2.12 1.5 1.5 0 0 0 2.12 0L10 7.08a0.5 0.5 0 0 1 0.67 0l2.88 2.31A2.52 2.52 0 0 0 17 9.1l3.46 -3.73a0.23 0.23 0 0 1 0.18 -0.08 0.22 0.22 0 0 1 0.18 0.07l1.42 1.42a0.74 0.74 0 0 0 0.82 0.16 0.74 0.74 0 0 0 0.46 -0.69V0.75a0.76 0.76 0 0 0 -0.77 -0.75h-5.5a0.74 0.74 0 0 0 -0.69 0.46 0.74 0.74 0 0 0 0.16 0.82l1.6 1.6a0.25 0.25 0 0 1 0 0.35Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 21h-7a1.5 1.5 0 0 0 0 3h7a1.5 1.5 0 0 0 0 -3Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 24h7a1.5 1.5 0 0 0 0 -3H3a1.5 1.5 0 0 0 0 3Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 19.5a1.5 1.5 0 0 0 0 -3H2a1.5 1.5 0 0 0 0 3Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 18a1.5 1.5 0 0 0 -1.5 -1.5h-7a1.5 1.5 0 0 0 0 3h7a1.5 1.5 0 0 0 1.5 -1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15h7a1.5 1.5 0 0 0 0 -3h-7a1.5 1.5 0 0 0 0 3Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNationalDevelopment);
export default ForwardRef;